import React from 'react';
import styled from './index._less';
import SvgCloseBorder from '../../../image/close-border.svg';
import ContentLeft from '../ContentLeft';
import ContentRight from '../ContentRight';
import useLogin from '../../../hooks/use-login';


export default () => {

  const { handleCloseModal } = useLogin();
    
    return (
        <>
        <div className="login-content">
            <div className="login-content-flex">
                <div className="left">
                    <ContentLeft />
                </div>
                <div className="right">
                    <ContentRight />
                </div>
            </div>
            <div
                className="top-close-icon"
                onClick={ handleCloseModal }
            >
                <SvgCloseBorder />
            </div>
        </div>
        <style jsx>{ styled }</style>
      </>
    )
}
